<div
    ng-form="fieldRecordSurveyDetailsForm"
    class="well">
    <h5>Survey details</h5>

    <div class="row">
        <div class="col-xs-3">
            <label class="control-label required-input">Declared as special survey area</label>
            <div
                [ngClass]="{'has-radio-error': !isSpecialSurveyAreaValid() && submitted}"
                ng-class="{'has-radio-error': fieldRecordSurveyDetailsForm['specialSurveyArea' + $index].$invalid
                            && (fieldRecordSurveyDetailsForm['specialSurveyArea' + $index].$dirty || fieldRecordSurveyDetailsForm.$submitted)}">
                @for (option of specialSurveyAreaOptions; track option) {
                    <label class="nlr-radio">
                        <input
                            type="radio"
                            name="specialSurveyArea"
                            id="specialSurveyArea"
                            [value]="option.value"
                            [(ngModel)]="model.specialSurveyArea"
                            (ngModelChange)="onSpecialSurveyAreaChange(option.value)"
                            required />
                        <span>{{option.name}}</span>
                    </label>
                }
            </div>
        </div>
    </div>

    @if (selectedPurpose.controlConnection) {
        <div class="row">
            <div class="col-xs-3">
                <label class="control-label required-input">SSM geodetic connections</label>
                <div
                    [ngClass]="{'has-radio-error': !isSsmGeodeticConnectionsValid() && submitted}"
                    ng-class="{'has-radio-error': fieldRecordSurveyDetailsForm['ssmGeodeticConnections' + $index].$invalid
                            && (fieldRecordSurveyDetailsForm['ssmGeodeticConnections' + $index].$dirty || fieldRecordSurveyDetailsForm.$submitted)}">
                    @for (option of ssmGeodeticConnectionsOptions; track option) {
                        <label class="nlr-radio">
                            <input
                                type="radio"
                                name="ssmGeodeticConnections"
                                id="ssmGeodeticConnections"
                                [value]="option.value"
                                [ngModel]="model.ssmGeodeticConnections"
                                (ngModelChange)="onSsmConnectionsChange(option.value)"
                                required />
                            <span>{{option.name}}</span>
                        </label>
                    }
                </div>
            </div>
            @if (model.ssmGeodeticConnections) {
                <div
                    ng-if="$ctrl.model.ssmGeodeticConnections"
                    class="col-xs-9">
                    <div class="row">
                        <div class="col-xs-12">
                            <label class="control-label required-input">SSM names</label>
                        </div>
                    </div>
                    <div class="row">
                        @for (ssmConnection of geodeticConnectionsFiltered('SSM'); track ssmConnection; let i = $index) {
                            <div
                                ng-repeat="ssmConnection in $ctrl.model.geodeticConnections | filter: {markType: 'SSM'}"
                                class="col-xs-4">
                                <div
                                    class="input-group"
                                    [ngClass]="{'has-error': !isGeodeticConnectionNameValid('SSM', i) && submitted}"
                                    ng-class="{'has-error': fieldRecordSurveyDetailsForm['ssmName' + $index].$invalid
                                && (fieldRecordSurveyDetailsForm['ssmName' + $index].$dirty || fieldRecordSurveyDetailsForm.$submitted)}">
                                    <span class="input-group-addon">
                                        <i class="nlrp-icon nlrp-icon-edit"></i>
                                    </span>
                                    <input
                                        type="text"
                                        name="ssmName"
                                        id="ssmName"
                                        class="form-control"
                                        [(ngModel)]="ssmConnection.name"
                                        (ngModelChange)="onSsmGeodeticConnectionsChange($event, i)"
                                        required />
                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-add"
                                            title="Add SSM name"
                                            (click)="addSsmConnection(i)"
                                            ng-click="$ctrl.addSsmConnection($index)"></i>
                                    </span>
                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-remove"
                                            title="Remove SSM name"
                                            (click)="removeSsmConnection(i)"
                                            ng-click="$ctrl.removeSsmConnection($index)"></i>
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }

    @if (selectedPurpose.controlConnection) {
        <div class="row">
            <div class="col-xs-3">
                <label class="control-label required-input">Benchmark connections</label>
                <div
                    [ngClass]="{'has-radio-error': !isbenchmarkConnectionsValid() && submitted}"
                    ng-class="{'has-radio-error': fieldRecordSurveyDetailsForm['benchmarkConnections' + $index].$invalid
                            && (fieldRecordSurveyDetailsForm['benchmarkConnections' + $index].$dirty || fieldRecordSurveyDetailsForm.$submitted)}">
                    @for (option of benchmarkConnectionsOptions; track option) {
                        <label class="nlr-radio">
                            <input
                                type="radio"
                                name="benchmarkConnections"
                                [value]="option.value"
                                [ngModel]="model.benchmarkConnections"
                                (ngModelChange)="onBenchMarkConnectionsChange(option.value)"
                                required />
                            <span>{{option.name}}</span>
                        </label>
                    }
                </div>
            </div>
            @if (model.benchmarkConnections) {
                <div
                    ng-if="$ctrl.model.benchmarkConnections"
                    class="col-xs-9">
                    <div class="row">
                        <div class="col-xs-12">
                            <label class="control-label required-input">BM names</label>
                        </div>
                    </div>
                    <div class="row">
                        @for (bmConnection of geodeticConnectionsFiltered('BM'); track bmConnection; let i = $index) {
                            <div class="col-xs-4">
                                <div
                                    class="input-group"
                                    [ngClass]="{'has-error': !isGeodeticConnectionNameValid('BM', i) && submitted}"
                                    ng-class="{'has-error': fieldRecordSurveyDetailsForm['bmName' + $index].$invalid
                                && (fieldRecordSurveyDetailsForm['bmName' + $index].$dirty || fieldRecordSurveyDetailsForm.$submitted)}">
                                    <span class="input-group-addon">
                                        <i class="nlrp-icon nlrp-icon-edit"></i>
                                    </span>
                                    <input
                                        type="text"
                                        name="bmName"
                                        class="form-control"
                                        [(ngModel)]="bmConnection.name"
                                        (ngModelChange)="onBmGeodeticConnectionsChange($event, i)"
                                        required />
                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-add"
                                            title="Add BM name"
                                            (click)="addBmConnection(i)"></i>
                                    </span>
                                    <span class="input-group-addon">
                                        <i
                                            class="nlrp-icon nlrp-icon-remove"
                                            title="Remove BM name"
                                            (click)="removeBmConnection(i)"></i>
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }

    @if (selectedPurpose.controlConnection) {
        <div class="row">
            <div class="col-xs-3">
                <label class="control-label required-input">Non-geodetic connections (PSM, PCM, TCM)</label>
                <div
                    [ngClass]="{'has-radio-error': !isunnamedGeodeticConnectionValid() && submitted}"
                    ng-class="{'has-radio-error': fieldRecordSurveyDetailsForm['unnamedGeodeticConnection' + $index].$invalid
                            && (fieldRecordSurveyDetailsForm['unnamedGeodeticConnection' + $index].$dirty || fieldRecordSurveyDetailsForm.$submitted)}">
                    @for (option of unnamedGeodeticConnectionsOptions; track option) {
                        <label class="nlr-radio">
                            <input
                                type="radio"
                                name="unnamedGeodeticConnection"
                                [value]="option.value"
                                [(ngModel)]="model.unnamedGeodeticConnection"
                                (ngModelChange)="onUnnamedGeodeticConnectionsChange(option.value)"
                                required />
                            <span>{{option.name}}</span>
                        </label>
                    }
                </div>
            </div>
        </div>
    }
</div>
